import { createContext } from 'react';
export var GlobalThemeContext = createContext({
  globalTheme: null,
  setGlobalTheme: function setGlobalTheme() {},
  isChangeDisabled: false
});
export var LocalThemeContext = createContext({
  localTheme: null
});